import React from "react";
import MoveModal from "./MoveModal";
import MoveForm from "./MoveForm";
import ModalButtonRow from "./ModalButtonRow";
import BulkPromoNumberLabel from "./BulkPromoNumberLabel";
import WarningDropdown from "./WarningDropdown";
import bulkSuccessToast from "../utilities/bulk_success_toast";
import bulkErrorToast from "../utilities/bulk_error_toast";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

export default class BulkMoveModal extends MoveModal {
  successToast(virtualLineMover, destinationParams, errors) {
    const sentNumbers = virtualLineMover.validSourceNumbers();
    const failedNumbers = Object.keys(errors);
    virtualLineMover.setServerErrors(errors);
    const toastErrors = virtualLineMover.headerErrors();
    const movedNumbers = sentNumbers.filter((number) => !failedNumbers.includes(number.name));

    bulkSuccessToast(movedNumbers, destinationParams);
    if (toastErrors.length > 0) {
      bulkErrorToast(toastErrors);
    }
  }

  render() {
    const { isOpen, virtualLineMover } = this.state;

    return (
      <div ref={this.modalRef}>
        <Modal isOpen={isOpen} toggle={this.toggleModal} className="modal-force-light">
          <ModalHeader toggle={this.toggleModal}>Move Promo Numbers</ModalHeader>

          <ModalBody>
            <MoveForm
              virtualLineMover={virtualLineMover}
              updateForm={this.updateVirtualLineMover.bind(this)}
            >
              <BulkPromoNumberLabel count={virtualLineMover.validSourceNumbers().length}/>
            </MoveForm>
            <WarningDropdown warnings={virtualLineMover.lineItemSourceErrors()} />
          </ModalBody>

          <ModalFooter>
            <ModalButtonRow
              toggle={this.toggleModal}
              submitAction={this.onMove}
              errorMessage={virtualLineMover.errorMessages()}
              valid={virtualLineMover.valid()}
            />
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
